import { employeeTermination } from "../../api/salary";
import { useMutation, useQueryClient } from "@tanstack/react-query";

interface ITerminateEmployeesButton {
  empId: string;
}

const TerminateEmployeesButton = ({ empId }: ITerminateEmployeesButton) => {
  const queryClient = useQueryClient();
  const activateEmpMutation = useMutation({
    mutationFn: () => employeeTermination(empId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["salary"] });
      queryClient.invalidateQueries({ queryKey: ["terminated_employees"] });
    },
  });
  return (
    <button
      className="styled-btn--std"
      onClick={() => {
        if (confirm("Are you sure?")) {
          activateEmpMutation.mutate();
        }
      }}
    >
      Activate
    </button>
  );
};

export default TerminateEmployeesButton;
